import { GridRenderCellParams } from '@mui/x-data-grid';
import styled from 'styled-components';
import { IconButton, Tooltip } from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { downloadFileFromUrl } from '../../utils/downloadFileFromUrl';
import { getCheckDownloadLink } from '../../api/getCheckDownloadLink';
import { CheckDetails } from '../../interfaces';

export const LongTextCellWrapper = styled.div`
    position: relative;
    padding-right: 40px;
    display: flex;
`;

export const CheckActionsCell = (cellValues: GridRenderCellParams) => {
    const check = cellValues.row as CheckDetails;
    return (
        <LongTextCellWrapper>
            {check?.Url ? (
                <>
                    <span>
                        <Tooltip title="Переглянути" placement="top">
                            <IconButton
                                size="small"
                                onClick={async () => {
                                    const presignedUrl = await getCheckDownloadLink(check.id);
                                    const keyParts = presignedUrl.split('/');
                                    await downloadFileFromUrl(presignedUrl, keyParts[keyParts.length - 1]);
                                }}
                                edge="end"
                                aria-label="look"
                            >
                                <RemoveRedEyeIcon />
                            </IconButton>
                        </Tooltip>
                    </span>
                </>
            ) : (
                <></>
            )}
        </LongTextCellWrapper>
    );
};
